import React, {Component} from 'react';
import {
    Link
} from "react-router-dom";

import Menu from "../Menu";
import PageHeader from "../PageHeader";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import axios from "axios";

export class KnowledgeCategories extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            category:[]
        };
    }

    componentDidMount() {
        let urlAPI = GlobalVariable.staffBack() + '/getLessonCategorys';
        let data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                this.setState({'category': result.data})
            }).catch(error => {

            // window.location.href = '/' ;
        })
    }

    render() {
        return (
            <div className='main knowledge-categories'>
                <div className='content mx-w-content'>

                    <PageHeader
                        pageTitle='База знаний'
                        backBtnUrl='/'/>
                    <div className='pt-header'></div>
                    {this.state.category.map((item)=>(
                        <Link to={"/knowledge-base/"+item.id}>
                            <div className='ml-3 mr-3 mb-2'>
                                <div className='chio-card-subheader bg-red d-flex justify-content-between pl-3 pr-3 pt-2'>
                                    <div className='text-white'>{item.title}</div>
                                    <div className='text-white'>{item.count}</div>
                                </div>
                                <div className='chio-card'>
                                    <img className='card-img-wh' src={item.img_url} alt=''/>
                                    <div className='more text-white txt-middle position-absolute'>Подробнее</div>
                                </div>
                            </div>
                        </Link>
                    ))}




                </div>
                <Menu></Menu>
            </div>
        )
    }
}

export default KnowledgeCategories;